<template>
  <div class="w100 pl20 pr20">
    <el-form :inline="true" label-width="100px" :rules="rules" :model="form" ref="ruleForm" class="demo-form-inline">
      <el-form-item label="服务对象" prop="obj" style="width: 40%;">
        <el-select style="width: 250px;" v-model="form.obj" multiple placeholder="请选择服务对象">
          <el-option v-for="item in prorData.obj" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务主题" prop="theme" style="width: 40%;">
        <el-select style="width: 250px;" v-model="form.theme" multiple placeholder="请选择服务主题">
          <el-option v-for="item in prorData.theme" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务名称" prop="name" style="width: 40%;">
        <el-input style="width: 250px;" v-model="form.name" placeholder="请输入服务名称"></el-input>
      </el-form-item>
      <el-form-item label="PC端链接" prop="linkUrl" style="width: 30%; min-width: 250px;">
        <el-input v-model="form.linkUrl" placeholder="请输入PC端链接"></el-input>
      </el-form-item>
      <el-form-item label="手机端链接" prop="mobileUrl" style="width: 40%; min-width: 250px;">
        <el-input v-model="form.mobileUrl" placeholder="请输入手机端链接"></el-input>
      </el-form-item>
      <el-form-item label="推荐服务" prop="recommend" style="width: 40%;">
        <el-switch v-model="form.recommend" active-color="#409EFF" inactive-color="#cdcdcd"></el-switch>
      </el-form-item>
      <el-form-item label="可用平台" prop="terminal" style="width: 40%; min-width: 250px;">
        <el-checkbox-group v-model="form.terminal">
          <el-checkbox label="pc">PC平台</el-checkbox>
          <el-checkbox label="mobile">移动平台</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="服务图标" prop="imgUrl" class="upload-img" style="width: 40%;">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <el-upload ref="upload" class="avatar-uploader" :action="uploadUrl" :headers="uploadHeader" accept=".png" :on-change="onChange" :on-success="onSuccess" :on-error="onError" :auto-upload="false" :show-file-list="false">
            <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span style="font-size: 12px; color: #e6a23c; padding-left: 8px;">png格式，大小80*80像素，建议20KB以内.</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ServeError",
  components: {},
  props: ["prorData"],
  data() {
    // 验证地址
    var urlVerify = (rule, value, callback) => {
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/i.test(
        value
      );
      if (!reg) {
        callback(new Error("请输入正确地址！"));
        return;
      }
      callback();
    };
    return {
      baseUrl: process.env.BASE_URL,
      form: {
        serveId: "", //
        formType: "three", // 用于局别三种类型
        name: "", // 服务名称
        obj: [], // 服务对象
        theme: [], // 主题
        recommend: false, // 是否推荐  不推荐：0，推荐：1
        imgUrl: "", // 服务图标
        imgId: "", // 上传之后的Id
        processDefId: "", // 服务Id
        processVersionId: "", // 流程版本Id
        linkUrl: "", // 站外链接
        mobileUrl: "",
        terminal: [],
      },
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload", // 上传地址
      uploadHeader: {}, // 上传接口header设置
      rules: {
        obj: [{ required: true, message: "请选择服务对象", trigger: "blur" }],
        theme: [{ required: true, message: "请选择服务主题", trigger: "blur" }],
        name: [{ required: true, message: "请入服务名称", trigger: "blur" }],
        imgUrl: [
          { required: true, message: "请选择服务图标", trigger: "blur" },
        ],
        linkUrl: [
          { required: true, message: "请输入PC端链接", trigger: "blur" },
        ],
        mobileUrl: [
          { required: true, message: "请输入手机端链接", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["userToken"]),
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 默认判断，有详情值的话，回显；
    initFn() {
      if (JSON.stringify(this.prorData.infoFrom) !== "{}") {
        let data = this.prorData.infoFrom;

        this.form.serveId = data.serveId;
        this.form.formType = data.formType; // 用于局别三种类型
        this.form.name = data.name; // 服务名称
        this.form.obj = data.obj; // 服务对象
        this.form.theme = data.theme; // 主题
        this.form.recommend = data.recommend; // 是否推荐
        this.form.imgUrl = data.imgUrl; // 服务图标
        this.form.imgId = data.imgId; // 图标Id
        this.form.processDefId = data.processDefId; // 服务Id
        this.form.processVersionId = data.processVersionId; // 流程版本Id
        this.form.linkUrl = data.linkUrl; // 站外链接
        this.form.mobileUrl = data.mobileUrl;
        this.form.terminal = data.terminal.split(",");
      } else {
        this.$nextTick(() => {
          this.form.terminal = ["pc", "mobile"];
        });
      }
    },

    // 验证 在上一个组件调用，并 return form的值回上个组件(Dialog.vue)
    validateForm(formName) {
      // 验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 过滤默认空数据
          this.form.terminal = this.form.terminal.filter((item) => {
            return item !== "";
          });

          // 如果还存在图片id、则不用再跑上传流程
          if (this.form.imgId === "") {
            // 提交的时候上传文件
            this.$refs.upload.submit();
          } else {
            this.$emit("backFn", this.form);
          }
        }
      });
    },

    // 选中图片(用于选中未提交时，显示图片)
    // 选中的时候、验证图片格式、大小
    // 设置 请求 header
    // 设置 图片选择框中显示图标
    onChange(file) {
      let arr = [];
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.size / 1024 < 21;

      if (!isPNG) {
        this.form.imgUrl = "";
        this.$message.error("上传服务图标只能是 PNG 格式!");
        return;
      }
      if (!isLt2M) {
        this.form.imgUrl = "";
        this.$message.error("上传服务图标大小不能超过 20KB!,请重新上传。");
        return;
      }

      // 变更图标之后重新赋值，保持只有有个图标
      arr.push(file);
      this.$refs.upload.uploadFiles = arr;

      this.form.imgId = ""; // 选择新图片，id要为空
      this.uploadHeader = {
        token: this.userToken,
        Authorization: "bearer " + this.$keycloak.token,
      }; // 设置上传的 headers token
      this.form.imgUrl = URL.createObjectURL(file.raw);
    },

    // 上传成功
    // 上传成功之后、设置 已上传图标的id;
    onSuccess(response) {
      this.$nextTick(() => {
        this.form.imgId = response.resData[0];
        this.$emit("backFn", this.form);
      });
    },

    // 上传错误
    onError() {
      this.$message.error("图标上传错误！");
      this.$nextTick(() => {
        this.form.imgUrl = "";
      });
    },
  },
  watch: {
    prorData: {
      handler() {
        this.initFn();
      },
      immediate: true,
    },
  },
  filters: {},
};
</script>

<style scoped>
.avatar-uploader {
  width: 32px;
  height: 32px;
  display: block;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.avatar-uploader .avatar {
  width: 32px;
  height: 32px;
  display: block;
}
</style>
